import {postCopyStream, postCopy} from "./copywriting-post";
import {selectiontext} from "./copywriting";

export var addDropdownToMenu = function (quill, action = null, form_name = 'formCopywriting', stream = false) {
    const dropDownItems = {


        'Write more...': 'write_more',
        'Write an Alternative Version': 'write_alternative_version',
        'Write a Shorter Version': 'write_shorter_version',
        'Write a Longer Version': 'write_longer_version',
        'Write a Headline': 'write_landingpage_headline',
        'Write a Title': 'insert_blogpost_title',
        'Write an Introduction': 'insert_blogpost_introduction',
        'Write a Paragraph Section': 'write_blog_section_paragraph',
        'Write a Bullet Point Section': 'write_blog_section_bulletpoints',
        'Write a Conclusion': 'insert_blogpost_conclusion',
        'Write Keywords used': 'insert_keywords'
    }

    const myDropDown = new QuillToolbarDropDown({
        id: "btncreate",
        label: "Highlight Text...",
        rememberSelection: false
    })

    myDropDown.setItems(dropDownItems)

    myDropDown.onSelect = function (label, value, quill) {
        // Do whatever you want with the new dropdown selection here

        // For example, insert the value of the dropdown selection:
        // const {index, length} = outputbox.selection.savedRange
        // // //
        // outputbox.setSelection(index, length, 'silent')
        // outputbox.focus();
        var qltoolbar = document.querySelector(".ql-toolbar")
        qltoolbar.append(document.getElementById('form_error'))
        if (stream) {
            postCopyStream(action, value, form_name);
            // console.log('stream request')
        } else {
            postCopy(action, value, form_name)
            // console.log('post request')
        }


        // document.getElementById("formCopywriting").submit(value);
    }




    const myButton = new QuillToolbarButton({
        icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="90.05 198.46 819.9 603.12"> <defs> <style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#0e0e0e;}</style> <linearGradient id="linear-gradient" x1="215.04" y1="379.2" x2="846.45" y2="721.03"gradientTransform="matrix(1, 0, 0, 1, 0, 0)" gradientUnits="userSpaceOnUse"> <stop offset="0" stop-color="#ee2971"/> <stop offset="1" stop-color="#631bbd"/> </linearGradient></defs><g> <path className="cls-2"d="M812.97,460.5c-78.14-107.31-220.48-124.85-291.29-126.53-5.88-.14-10.56-4.92-10.56-10.8v-11.56c0-2.05,1.32-3.8,3.23-4.52,21.24-7.99,36.34-28.49,36.34-52.52,0-33.08-28.62-59.47-62.45-55.76-25.56,2.8-46.4,23.48-49.38,49.03-3.13,26.82,12.7,50.47,35.89,59.2,1.91,.72,3.23,2.47,3.23,4.52v12c0,5.8-4.54,10.54-10.33,10.79-73.63,3.18-206.23,23.99-280.62,126.16-5.76,7.96-8.86,17.61-8.86,27.44v159.48c0,9.82,3.1,19.48,8.86,27.44,87.27,119.85,254.6,127.75,312.97,126.62,58.37,1.13,225.69-6.77,312.97-126.62,5.81-7.96,8.86-17.61,8.86-27.44v-159.48c0-9.82-3.05-19.48-8.86-27.44Zm-312.95,262.78c-145.59,0-263.63-38.67-263.63-184.26,0-65.74,24.06-99.43,63.89-116.57,16.94-7.29,35.39-10.39,53.83-10.39h291.84c18.44,0,36.89,3.09,53.83,10.39,39.83,17.15,63.89,50.83,63.89,116.57,0,145.59-118.04,184.26-263.63,184.26Z"/> <path className="cls-2"d="M156.49,484.63v173.26c-36.71,0-66.44-38.76-66.44-86.63s29.73-86.63,66.44-86.63Z"/> <path className="cls-2"d="M843.51,657.88v-173.26c36.71,0,66.44,38.76,66.44,86.63s-29.73,86.63-66.44,86.63Z"/> <circle className="cls-2" cx="649.58" cy="554.64" r="43.35"/> <circle className="cls-2" cx="355.96" cy="554.64" r="43.35"/> <path className="cls-2"d="M529.46,633.23c-6.1,0-12.19-2.25-17.29-6.75l-11.04-9.77c-1.63-1.45-3.02-1.43-4.65,0l-9.84,8.72c-10.18,9.01-24.39,9.01-34.57,0l-21.45-18.98c-4.67-4.13-5.11-11.27-.98-15.94,4.13-4.66,11.27-5.12,15.94-.98l21.45,18.98c1.63,1.44,3.02,1.45,4.64,0l9.85-8.72c10.18-9,24.39-9,34.57,0l11.04,9.77c1.63,1.44,3.01,1.44,4.64,0l22.63-20.02c4.67-4.14,11.81-3.7,15.94,.98,4.13,4.67,3.69,11.8-.98,15.94l-22.62,20.02c-5.09,4.5-11.19,6.75-17.28,6.75Z"/></g><g> <path className="cls-1"d="M812.97,460.5c-78.14-107.31-220.48-124.85-291.29-126.53-5.88-.14-10.56-4.92-10.56-10.8v-11.56c0-2.05,1.32-3.8,3.23-4.52,21.24-7.99,36.34-28.49,36.34-52.52,0-33.08-28.62-59.47-62.45-55.76-25.56,2.8-46.4,23.48-49.38,49.03-3.13,26.82,12.7,50.47,35.89,59.2,1.91,.72,3.23,2.47,3.23,4.52v12c0,5.8-4.54,10.54-10.33,10.79-73.63,3.18-206.23,23.99-280.62,126.16-5.76,7.96-8.86,17.61-8.86,27.44v159.48c0,9.82,3.1,19.48,8.86,27.44,87.27,119.85,254.6,127.75,312.97,126.62,58.37,1.13,225.69-6.77,312.97-126.62,5.81-7.96,8.86-17.61,8.86-27.44v-159.48c0-9.82-3.05-19.48-8.86-27.44Zm-312.95,262.78c-145.59,0-263.63-38.67-263.63-184.26,0-65.74,24.06-99.43,63.89-116.57,16.94-7.29,35.39-10.39,53.83-10.39h291.84c18.44,0,36.89,3.09,53.83,10.39,39.83,17.15,63.89,50.83,63.89,116.57,0,145.59-118.04,184.26-263.63,184.26Z"/> <path className="cls-1"d="M156.49,484.63v173.26c-36.71,0-66.44-38.76-66.44-86.63s29.73-86.63,66.44-86.63Z"/> <path className="cls-1"d="M843.51,657.88v-173.26c36.71,0,66.44,38.76,66.44,86.63s-29.73,86.63-66.44,86.63Z"/> <circle className="cls-1" cx="649.58" cy="554.64" r="43.35"/> <circle className="cls-1" cx="355.96" cy="554.64" r="43.35"/> <path className="cls-1"d="M529.46,633.23c-6.1,0-12.19-2.25-17.29-6.75l-11.04-9.77c-1.63-1.45-3.02-1.43-4.65,0l-9.84,8.72c-10.18,9.01-24.39,9.01-34.57,0l-21.45-18.98c-4.67-4.13-5.11-11.27-.98-15.94,4.13-4.66,11.27-5.12,15.94-.98l21.45,18.98c1.63,1.44,3.02,1.45,4.64,0l9.85-8.72c10.18-9,24.39-9,34.57,0l11.04,9.77c1.63,1.44,3.01,1.44,4.64,0l22.63-20.02c4.67-4.14,11.81-3.7,15.94,.98,4.13,4.67,3.69,11.8-.98,15.94l-22.62,20.02c-5.09,4.5-11.19,6.75-17.28,6.75Z"/> </g> </svg>'

    })


    myButton.onClick = function (quill) {
        event.preventDefault();
        if (selectiontext.length > 1) {
            var qltoolbar = document.querySelector(".ql-toolbar")
            qltoolbar.append(document.getElementById('form_error'))


            if (stream) {
                postCopyStream(null, 'ai_assistant', form_name);
                // console.log('stream request')
            } else {
                postCopy(null, 'ai_assistant', form_name)
                // console.log('post request')
            }


        } else {
            alert('Highlight a command for Wilfie')
        }

    }


    myButton.attach(quill, false)
     myDropDown.attach(quill, false)
}
